
class Utils {
  checkIsValidObjectIdForMongoDB (id) {
    return typeof id === 'string' && /^[0-9a-fA-F]{24}$/.test(id)
  }

  hashCode (str) {
    var hash = 0

    if (str.length === 0) {
      return hash
    }

    for (let i = 0; i < str.length; i++) {
      let char = str.charCodeAt(i)
      hash = ((hash << 5) - hash) + char
      hash = hash & hash // Convert to 32bit integer
    }
    return hash
  }

  // Return uid in MongoDB ObjectID format
  genUID () {
    return 'xxxxxxxxxxxxxxxxxxxxxxxx'.replace(/x/g, function () {
      var rand
      try {
        rand = crypto.getRandomValues((new Uint8Array(1)))[0] % 16
      } catch (e) {
        rand = Math.floor(Math.random() * 16)
      }
      return rand.toString(16)
    })
  }

  setFormIdToForms () {
    let forms = document.getElementsByTagName('form')
    for (let i = 0; i < forms.length; i++) {
      let form = forms[i]
      if (!form._lh_formid) {
        // Set unique id on form
        form._lh_formid = this.genUID()
      }
    }
  }

  getElemValue (el) {
    switch (el.nodeName.toUpperCase()) {
      case 'INPUT': {
        switch (el.type.toLowerCase()) {
          case 'checkbox':
          case 'radio':
            if (el.checked) {
              return el.value
            }
            break
          case 'text':
          case 'email':
          case 'hidden':
          case 'submit':
          case 'button':
          case 'tel':
          case 'image':
          // dirty hack for preventing write `dumb` values to lead profile.
            if ((el.value === '+7 (___) ___-__-__') || (el.value === '(___)___-__-__')) {
              return ''
            }
            return el.value
          default: {
            return el.value
          }
        }
        break
      }
      case 'TEXTAREA': {
        return el.value
      }
      case 'SELECT': {
        if (el.type.toLowerCase() !== 'select-multiple') {
          if (el.options[el.selectedIndex]) {
            return el.options[el.selectedIndex].text
          } else {
            return ''
          }
        }
        break
      }
      default: {
        break
      }
    }
    return ''
  }

  checkformsWithHashedFields (form) {
    for (var formSelector in formsWithHashedFields) {
      if (form === document.querySelector(formSelector)) {
        return formSelector
      }
    }
    return false
  }

  makeQuery (params) {
    // Escape params and generate query string

    var query = ''
    for (let key in params) {
      query += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
    }
    return query.replace(/&$/, '')
  }

  readCookie (name) {
    if (document.cookie.length > 0) {
      let offset = document.cookie.indexOf(name + '=')
      if (offset !== -1) {
        offset = offset + name.length + 1
        let tail = document.cookie.indexOf(';', offset)
        if (tail === -1) tail = document.cookie.length
        return unescape(document.cookie.substring(offset, tail))
      }
    }
    return null
  }

  setCookie (name, value, expires, path, domain, secure) {
    path = '/'

    if (!name || !value) {
      return false
    }

    var str = name + '=' + encodeURIComponent(value)

    if (expires) {
      str += '; expires=' + expires.toUTCString()
    }

    if (path) {
      str += '; path=' + path
    }

    if (domain) {
      str += '; domain=' + domain
    } else {
      str += '; domain=.' + window.location.hostname.replace('www.', '')
    }

    if (secure) {
      str += '; secure'
    }

    document.cookie = str

    return true
  }

  createCookie (name, value, minutes, esc) {
    var date = new Date()
    date.setTime(date.getTime() + minutes * 1000 * 60)
    if (esc) {
      value = escape(value)
    }
    var rootDomain = location.hostname.split('.').reverse().slice(0, 2).reverse().join('.')

    if (window.hasOwnProperty('lh_tracker_for_current_host') && window.lh_tracker_for_current_host === true) {
      document.cookie = name + '=' + value + ';path=/' + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
    } else {
      var cookie = document.cookie = name + '=' + value + ';path=/;domain=.' + rootDomain + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
      // get short part 'name=value' of full cookie value
      var shortCookie = cookie.split(';')[0]
      var isCookieCreated = document.cookie.indexOf(shortCookie) !== -1
      // if cookie was not saved, try to create it on third level domain
      if (!isCookieCreated) {
        var thirdLevelDomain = location.hostname.split('.').reverse().slice(0, 3).reverse().join('.')
        document.cookie = name + '=' + value + ';path=/;domain=.' + thirdLevelDomain + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
      }
    }
  }

  createComplexCookie (name, values, minutes, esc) {
    var date = new Date()
    date.setTime(date.getTime() + minutes * 1000 * 60)
    var value = ''
    for (let i = 0; i < values.length; i++) {
      if (esc) {
        values[i] = escape(values[i])
      }
    }
    value = values.join('|')
    var rootDomain = location.hostname.split('.').reverse().slice(0, 2).reverse().join('.')

    if (window.hasOwnProperty('lh_tracker_for_current_host') && window.lh_tracker_for_current_host === true) {
      document.cookie = name + '=' + value + ';path=/' + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
    } else {
      var cookie = document.cookie = name + '=' + value + ';path=/;domain=.' + rootDomain + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
      // get short part 'name=value' of full cookie value
      var shortCookie = cookie.split(';')[0]
      var isCookieCreated = document.cookie.indexOf(shortCookie) !== -1
      // if cookie was not saved, try to create it on third level domain
      if (!isCookieCreated) {
        var thirdLevelDomain = location.hostname.split('.').reverse().slice(0, 3).reverse().join('.')
        document.cookie = name + '=' + value + ';path=/;domain=.' + thirdLevelDomain + ((minutes === null) ? '' : ';expires=' + date.toUTCString())
      }
    }
  }

  closestByTagName (el, tagName) {
    // Traverse the DOM up with a while loop
    while (('' + el.tagName).toLowerCase() !== tagName) {
      // Increment the loop to the parent node
      el = el.parentNode
      if (!el) {
        return null
      }
    }
    // At this point, the while loop has stopped and `el` represents the element that has
    // the tag name you specified in the second parameter of the function `tagName`

    // Then return the matched element
    return el
  }

  getReferrer () {
    if (this.getURLParameter('lhsource') === 'recommendations') {
      return 'recommendations'
    }

    let leadhitMessageID = this.getURLParameter('lh_message_id')
    if (leadhitMessageID) {
      return `mail_${leadhitMessageID}`
    }

    if (this.getURLParameter('_openstat')) {
      return 'yad'
    }

    if (this.getURLParameter('gclid')) {
      return 'adwords'
    }
    if (this.getURLParameter('utm_source') === 'telegram') {
      return 'telegram'
    }

    let leadhitCampaign = this.getURLParameter('lh_campaign')
    if (leadhitCampaign) {
      return `lh_campaign_${leadhitCampaign}`
    }

    if (document.referrer.indexOf(window.location.origin) === 0) {
      return 'inner'
    }

    if (document.referrer.length === 0) {
      return 'direct'
    }
    return new URL(document.referrer).origin
  }

  getHostname (url) {
    url = url.toString()
    url = url.replace('/www.', '/')
    let m = ((url || '') + '').match(/^https?:\/\/[^/]+/)
    return m ? m[0] : ''
  }

  getURLParameter (name, str) {
    let url = str || location.search
    return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(url) || [, ''])[1]) // eslint-disable-line
  }

  SetDiffTime (xhr) {
    let lhDiffTime = Date.parse(xhr.headers.map.date) - Date.now()
    localStorage.setItem('lhDiffTime', lhDiffTime)
  }

  detectChromeAutoFill (event) {
    if (window.navigator.userAgent.indexOf('Chrome') > -1) {
      let eventType = typeof event.inputType
      let targetType = event.target.type
      let nodeName = event.target.nodeName
      return nodeName === 'INPUT' && targetType !== 'checkbox' && eventType === 'undefined'
    }

    return false
  }
}

export default new Utils()
